export const COURSE_TYPE = {
  ONLINE_COURSE: 'onlineCourse',
  COURSE: 'course',
} as const;

export const ENTITY_TYPE = {
  ONLINE_COURSE: 'online-course',
  COURSE: 'course',
} as const;

export const USER_ROLE = {
  STUDENT: 'STUDENT',
  ADMIN: 'ADMIN',
  TEACHER: 'TEACHER',
  MANAGER: 'MANAGER',
  SUPER_TEACHER: 'SUPER_TEACHER',
  USER: 'USER',
  AUTHOR: 'AUTHOR',
} as const;

export const NOT_FILE_TYPE = {
  COURSE: 'course',
  FOLDER: 'folder',
  FOLDER_WITH_FILE_TYPES: 'folder-with-file-types',
  EXERCISE: 'exercise',
  LINK: 'link',
  PERSONAL_EXERCISE: 'personal-exercise',
  COURSE_CATEGORY: 'course-category',
} as const;

export const LIST_ITEM_TYPE = {
  EXTENDED: 'EXTENDED',
  CONCISE: 'CONCISE',
  BANNER: 'BANNER',
  COURSE: 'COURSE',
  BLOG_BANNER: 'BLOG_BANNER',
  TILE: 'TILE',
} as const;

export const LIST_VIEW_TYPE = {
  ROW: 'ROW',
  TILE: 'TILE',
} as const;

export const CROPPED_IMAGE = {
  SMALL: {
    WIDTH: 100,
    ASPECT: 2.46,
  },
  MEDIUM: {
    WIDTH: 200,
    ASPECT: 2.57,
  },
  COURSE_IMAGE: {
    WIDTH: 100,
    ASPECT: 2.83,
  },
  LARGE: {
    WIDTH: 100,
    ASPECT: 2.8,
  },
} as const;

export const CROPPED_THUMBNAIL = {
  SMALL: {
    WIDTH: 100,
    ASPECT: 1,
  },
  MEDIUM: {
    WIDTH: 200,
    ASPECT: 1.34,
  },
  LOGO: {
    WIDTH: 100,
    ASPECT: 2.6,
  },
  AVATAR: {
    WIDTH: 100,
    ASPECT: 1,
  },
  COURSE_IMAGE: {
    WIDTH: 100,
    ASPECT: 1.9,
  },
  LARGE: {
    WIDTH: 100,
    ASPECT: 0.62,
  },
} as const;

export const COURSE = 'COURSE';
export const COURSE_AND_SUPPORT = 'COURSE_AND_SUPPORT';

export const LESSON_EXECUTION_STATUS = {
  LESSON_STARTED: 'LESSON_STARTED',
  LESSON_COMPLETE: 'LESSON_COMPLETE',
  LESSON_IS_NOT_COMPLETE: 'LESSON_IS_NOT_COMPLETE',
  LESSON_IS_NOT_STARTED: 'LESSON_IS_NOT_STARTED',
  LESSON_IS_NOT_ESTABLISHED: 'LESSON_IS_NOT_ESTABLISHED',
} as const;

export const DIALOG_TYPE = {
  SUPPORT: 'support',
  COURSE: 'course',
  ONLINE_COURSE: 'onlineCourse',
} as const;

export const CONSULTATION_TYPE = {
  CONSULTATION_AFTER_FINISHED_COURSE: 'consultationAfterFinishedCourse',
  COURSE: 'course',
  ZERO_LESSON: 'zeroLesson',
} as const;

export const SPEED_READING_FOR_ADULTS_LANDING_BLOCKS = {
  MAIN_BLOCK: 'main-block',
  TEST_BLOCK: 'test-block',
  CONVENIENT_TRAINING_FORMAT_BLOCK: 'convenient-training-format-block',
  COURSE_DESCRIPTION_BLOCK: 'course-description-block',
  FOR_WHOM_BLOCK: 'for-whom-block',
  ABOUT_AUTHOR_BLOCK: 'about-author-block',
  MAIN_QUESTIONS_BLOCK: 'main-questions-block',
  VIDEO_FEEDBACKS_BLOCK: 'video-feedbacks-block',
  PRICES_BLOCK: 'prices-block',
  SKYPE_CONSULTATION_BLOCK: 'skype-consultation-block',
  FORM_OF_PAYMENT_BLOCK: 'form-of-payment-block',
  CONTACTS_BLOCK: 'contacts-block',
} as const;

export type CourseType = (typeof COURSE_TYPE)[keyof typeof COURSE_TYPE];
export type EntityType = (typeof ENTITY_TYPE)[keyof typeof ENTITY_TYPE];

export type ListItemType = (typeof LIST_ITEM_TYPE)[keyof typeof LIST_ITEM_TYPE];
export type ListViewType = (typeof LIST_VIEW_TYPE)[keyof typeof LIST_VIEW_TYPE];
export type DialogType = (typeof DIALOG_TYPE)[keyof typeof DIALOG_TYPE];
export type ConsultationType = (typeof CONSULTATION_TYPE)[keyof typeof CONSULTATION_TYPE];
export type LessonExecutionStatus = (typeof LESSON_EXECUTION_STATUS)[keyof typeof LESSON_EXECUTION_STATUS];
